<template>
  <v-main>
    <record-info :noHiding="true" />

    <!-- SNACK BAR NOTIFIER -->
    <snackbar-notifier />

    <app-footer />
  </v-main>
</template>


<script>
import RecordInfo from './RecordInfo';
import AppFooter from '@/components/AppFooter';
import { mapState, mapMutations } from 'vuex';
import SnackbarNotifier from '@/components/SnackbarNotifier';

export default {
  name: 'preview-article',
  components: { AppFooter, SnackbarNotifier, RecordInfo },


  watch: {
    '$route': {
      async handler(route) {
        const recordId = route.params.id;
        this.fetchRecord(recordId);
      },
      deep: true,
      immediate: true,
    }
  },


  methods: {
    ...mapMutations('articles', ['SHOW_RECORD_INFO']),

    fetchRecord(recordId) {
      this.$store.dispatch('articles/fetchRecord', { id: recordId })
        .then(() => {
          this.SHOW_RECORD_INFO();
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        });
    },
  }
}
</script>